import React, { useEffect, useState } from 'react'
import { Row, Col, Form, Card, Button, Divider, Checkbox, Modal, Input } from 'antd'
import { connect } from 'react-redux'

import InputField from 'components/InputField'
import TextAreaField from 'components/TextArea'
import SelectField from 'components/SelectField'
import FileUpload from 'components/fileUpload'

import {
    SaveIco,
    SaveBlueIco,
    RefreshIco, SearchIco, MinusSmallIco, PlusSmallIco, ModalCloseIco, InputSearchIco,
    EroorIco,
} from "../../../../../modules/CustomIcons"


import './index.scss'
import '../../transfer.scss'
import { OWNACCOUNT } from "constants/constants";
import {Account, getAccounts, getSavedDocuments} from "../../../../services/account";
import { SelectOptions } from "../../../../services/form";
import { getCurrentCompany, getUserData } from "../../../../services/user";
import {
    checkAmountForRequest,
    fillCurrentForm,
    fillCurrentFormTemplate,
    financial,
    resetForm
} from "../../../../services/helper";
import AmountField from "components/AmountField";
import NextModal from "components/NextModal";
import {
    BankCodes,
    ClassificationCodes, getBankCodes,
    getClassificationCodes,
    getLevelCodes, getTeskilatCodesByFilter,
    LevelCodes, TeskilatCodes
} from "../../../../services/moneytransfer";
import { getDxaDocumentNumber } from "../../../../services/Accounts/DocumentNumber";
import { newMoneyTransferDxa } from "../../../../services/Transfers/Dxa";
import TemplatePopup from "components/TemplatePopup";
import { getCustomerCommission } from "../../../../services/Customers/Commission";
import SaveAsTemplate from "components/SaveAsTemplate";
import { useLocation } from "react-router-dom";
import { newMoneyTransferAzips } from "../../../../services/Transfers/Azips";
import FullScreenLoading from "components/FullScreenLoading";
import {setIbanNumber } from "../../../../store/actions/accountStatement";
import { useActions } from 'hooks/useActions'
import { useTranslation } from 'react-i18next'
import {deleteFileById} from "../../../../services/Transfers/Files";




const Dxa: React.FC<any> = ({ ownProps, ibanNumber }) => {
    const {t} = useTranslation()
    const modalDataInitial = {
        modalTitle: t("home.budgetSTA"),
        groups: [],
        pdfFiles: [],
        buttons: [
            { save: true },
            { sign: true },
            { approve: true },
            { send: true }
        ]
    };
    const [visible, setVisible] = useState(false);
    const [allAccounts, setAllAccounts] = useState<Account[]>();
    const [fromSelectOptions, setFromSelectOptions] = useState<SelectOptions[]>();
    const [levelCodeOptions, setLevelCodeOptions] = useState<SelectOptions[]>();
    const [fromBranch, setFromBranch] = useState<Account>();
    const [toBranch, setToBranch] = useState<BankCodes>();
    const [nextModalVisible, setNextModalVisible] = useState(false);
    const [templatePopupVisible, setTemplatePopupVisible] = useState(false);
    const [saveAsTemplatePopupVisible, setSaveAsTemplatePopupVisible] = useState<boolean>(false);
    const [codeModalVisible, setCodeModalVisible] = useState(false);
    const [classModalVisible, setClassModalVisible] = useState(false);
    const [modalData, setModalData] = useState(modalDataInitial);
    const [documentNumber, setDocumentNumber] = useState<string>('');
    const [bankCodes, setBankCodes] = useState<TeskilatCodes>();
    const [allBankCodes, setAllBankCodes] = useState<BankCodes>();
    const [classCodes, setClassCodes] = useState<ClassificationCodes>();
    const [allClassCodes, setAllClassCodes] = useState<any>();
    const [formFields, setFormFields] = useState({});
    const [commissionLoading, setCommissionLoading] = useState(false);
    const [commissionAmount, setCommissionAmount] = useState('');
    const [voenError, setVoenError] = useState(false);
    const [selectedAccount, setSelectedAccount] = useState(false);
    const [retryRequest, setRetryRequest] = useState(null);
    const [loadingAccount, setLoadingAccount] = useState(false);
    const [loadingData, setLoadingData] = useState(false);
    const [ibankRef, setIbankRef] = useState<string>('');
    const [pdfCount, setPdfCount] = useState(0);
    const [fileList, setFileList] = useState<any[]>([])
    const [tableData, setTableData] = useState<any[]>([])
    const [editOrRepeat,setEdit] = useState(false)
    const [showMessage,setShowMessage] = useState(false)
    const [accMessage,setAccMessage] = useState(false)
    const [form] = Form.useForm();
    const location = useLocation();
    const { setIbanNumber } = useActions();

    const addOrEditPage = ownProps?.addOrEditPage || false;

    const updateParentComponentFormData = () => {
        if (ownProps?.getFormElements) {
            ownProps?.getFormElements({form});
        }
    }

    const updateBankCodes = async (modalVisible: boolean = true) => {
        setAccMessage(false)
        const typed_code = form.getFieldValue('BENEFACC') || '';
        const typed_name = form.getFieldValue('BENEFBANKNAME_FILTER')?.toString()?.toLowerCase() || '';
        form.setFieldsValue({
            'BENEFNAME': ""
        });
        form.setFieldsValue({
            'BENEFTAXID': ""
        });
        form.setFieldsValue({
            'BENEFBANKCODE': ""
        });
        setFormFields(old_data => ({
            ...old_data,
            BENEFBANKCODE: "",
            BENEFNAME: "",
            BENEFTAXID: "",
        }))
        setBankCodes(old_data => { })
        if (typed_code.length >= 3 || typed_name.length >= 3) {
            const data = await getTeskilatCodesByFilter(typed_code, typed_name);
            setFormFields(old_data => ({
                ...old_data,
                BENEFBANKCODE: typed_code,
            }))
            if(data.length>0){
                setBankCodes(old_data => data);
            }else{
                setAccMessage(true)
            }

        }

        /*if (typed_code.length >= 3 || typed_name.length >= 3){
            const data = !allBankCodes ? await getBankCodes() : allBankCodes;

            setAllBankCodes(old_data => data);

            const filter_codes=data?.filter(row =>
                typed_code && typed_name ? row.CODE.includes(typed_code) && row.NAME.toString().toLowerCase().includes(typed_name) :

                    typed_code ? row.CODE.includes(typed_code) : typed_name ? row.NAME.toString().toLowerCase().includes(typed_name) : row
            );

            setFormFields(old_data => ({
                ...old_data,
                BENEFBANKCODE : typed_code,
            }))

            setBankCodes(old_data => filter_codes);
        }*/

        setCodeModalVisible(modalVisible);
        //setToBranch(old_data => filter_codes[0])
    }

    const updateToBankCodeAndName = (row) => {

        setFormFields(old_data => ({
            ...old_data,
            BENEFBANKCODE: row.code,
            BENEFNAME: row.name,
            BENEFACC: row.orgcode,
            BENEFTAXID: row.taxId,
        }))
        setSelectedAccount(true);
        setCodeModalVisible(false);
        setTimeout(() => { calculateCommission({ target: { value: form.getFieldValue('AMOUNT') } }) }, 100)
    }

    const updateClassCodes = async (modalVisible: boolean = true) => {
        const typed_code = form.getFieldValue('BUDGETCLASSCODE') || '';
        const typed_name = form.getFieldValue('BUDGETCLASSNAME_FILTER')?.toString()?.toLowerCase() || '';


        if(allClassCodes?.filter((data)=>data.code.includes(typed_code)).length === 0){

            setShowMessage(true)

        }else{
           
            setShowMessage(false)
        }

        if (typed_code.length >= 2 || typed_name.length >= 3) {
            const data = !allClassCodes ? await getClassificationCodes() : allClassCodes;

            setAllClassCodes(old_data => data);

            const filter_codes = data?.filter(row =>
                typed_code && typed_name ? row.code.includes(typed_code) && row.name.toString().toLowerCase().includes(typed_name) :

                    typed_code ? row.code.includes(typed_code) : typed_name ? row.name.toString().toLowerCase().includes(typed_name) : row
            );

            setFormFields(old_data => ({
                ...old_data,
                BUDGETCLASSCODE: typed_code,
            }))

            setClassCodes(old_data => filter_codes);
            setToBranch(old_data => filter_codes[0]);
        }else{
            setFormFields(old_data => ({
                ...old_data,
                BUDGETCLASSCODE: '',
            }))

        }

        setClassModalVisible(modalVisible);
    }

    const updateToClassCodeAndName = (row) => {

        setFormFields(old_data => ({
            ...old_data,
            BUDGETCLASSCODE: row.code
        }))

        setClassModalVisible(false);
    }

    const updateLevelCodes = async () => {
        const data = await getLevelCodes();

        let temp_data = [];

        for (let row of data) {

            // @ts-ignore
            temp_data.push({
                label: `${row.code}-${row.name}`,
                value: row.code
            });
        }

        setLevelCodeOptions(old_data => temp_data);
    }

    const fetchData = async () => {
        setLoadingAccount(true);
        const data = await getAccounts(getCurrentCompany());

        let temp_data = [];

        for (let row of data) {
            if (row.STATUS !== "0") {
                if (row.CCY_NAME.toString().toLowerCase() !== 'azn') {
                    continue;
                }

                // @ts-ignore
                temp_data.push({
                    label: row.NICKNAME ? row.NICKNAME : row.IBAN,
                    value: row.IBAN,
                    extra: `${financial(row.BALANCE_LC)} ${row.CCY_NAME}`
                });
            }
        }

        setAllAccounts(data.filter(row => row.STATUS !== "0"));
        setFromSelectOptions(old_data => temp_data);

        /**/
        if (location?.state?.trnData) {
            fillCurrentForm(form, location.state.trnData)
        }
        setLoadingAccount(false);
    };

    useEffect(() => {
        if (location.state?.data)
            loadData()
        else if (location.state?.trnData)
            loadDataTemplate2(location.state)
        else {
            fetchData();
            updateLevelCodes();
            callgetClassificationCodes();
        }

    }, [location.state]);

    const loadData = async () => {
        console.log('load560')
        setLoadingData(true)
        // load Account
        setLoadingAccount(true);
        const data = await getAccounts(getCurrentCompany());
        let temp_data = [];
        for (let row of data) {
            if (row.STATUS !== "0") {
                if (row.CCY_NAME.toString().toLowerCase() !== 'azn') {
                    continue;
                }

                // @ts-ignore
                temp_data.push({
                    label: row.NICKNAME ? row.NICKNAME : row.IBAN,
                    value: row.IBAN,
                    extra: `${financial(row.BALANCE_LC)} ${row.CCY_NAME}`
                });
            }
        }
        setAllAccounts(data.filter(row => row.STATUS !== "0"));
        setFromSelectOptions(old_data => temp_data);
        setLoadingAccount(false);
        setTableData(location.state?.data)
        const pdf = await getSavedDocuments(location.state?.data['ibankRef'])
        setFileList(pdf.data?.fileDetailsList)
        if (location.state?.edit){
            setEdit(true)
        }else{
            setEdit(false)
        }
        if (location.state?.edit)
            setIbankRef(location.state?.data['ibankRef'])
        setPdfCount(location.state?.data['attachedPDF'])
        // updateLevelCode
        const dataLevelCode = await getLevelCodes();
        let temp_dataDataLevelCode = [];
        for (let row of dataLevelCode) {
            // @ts-ignore
            temp_dataDataLevelCode.push({
                label: `${row.code}-${row.name}`,
                value: row.code
            });
        }
        setLevelCodeOptions(old_data => temp_dataDataLevelCode);
        // callgetClassificationCodes
        const dataClassCodes = await getClassificationCodes();
        setAllClassCodes(old_data => dataClassCodes);
        // CUSTACC
        const findAccount = data?.find(row => row.IBAN == location.state?.data['CUSTACC']);
        if (findAccount !== undefined) {
            setFromBranch(findAccount);
            if ((form.getFieldValue('PMTCUSTID') === "" || form.getFieldValue('PMTCUSTID') === undefined) && location.state?.edit === undefined) {
                updateDocumentNumber();
            } else if (location.state?.edit) {
                form.setFieldsValue({
                    'PMTCUSTID': location.state?.data['PMTCUSTID']
                });
            }
            form.setFieldsValue({
                'CUSTACC': location.state?.data['CUSTACC']
            });
        }
        // BENEFACC
        if (location.state?.data['BENEFACC'] !== undefined && location.state?.data['BENEFACC'] !== null) {
            const dataBENEFACC = await getTeskilatCodesByFilter(location.state?.data['BENEFACC'], '');
            if (dataBENEFACC !== undefined && dataBENEFACC.length > 0) {
                setFormFields(old_data => ({
                    ...old_data,
                    BENEFBANKCODE: dataBENEFACC[0].code,
                    BENEFNAME: dataBENEFACC[0].name,
                    BENEFACC: dataBENEFACC[0].orgcode,
                    BENEFTAXID: dataBENEFACC[0].taxId,
                }))
                setSelectedAccount(true);
            }
        }
        // BUDGETCLASSCODE
        if (location.state?.data['BUDGETCLASSCODE'] !== undefined && location.state?.data['BUDGETCLASSCODE'] !== null) {
            const filter_codes = dataClassCodes?.filter(row =>
                row.code.includes(location.state?.data['BUDGETCLASSCODE'])
            );
            if (filter_codes?.length > 0) {
                setFormFields(old_data => ({
                    ...old_data,
                    BUDGETCLASSCODE: filter_codes[0].code,
                }))
                setClassCodes(old_data => filter_codes);
                setToBranch(old_data => filter_codes[0]);
            }
        }

        // BUDGETLEVELCODE
        if (location.state?.data['BUDGETLEVELCODE'] !== undefined && location.state?.data['BUDGETLEVELCODE'] !== null) {
            // temp_dataDataLevelCode.find(u => u.value === location.state?.data['BUDGETLEVELCODE'])
            setFormFields(old_data => ({
                ...old_data,
                BUDGETLEVELCODE: location.state?.data['BUDGETLEVELCODE'],
            }))
            form.setFieldsValue({
                'BUDGETLEVELCODE': location.state?.data['BUDGETLEVELCODE']
            });
        }
        // AMOUNT
        form.setFieldsValue({
            'AMOUNT': checkAmountForRequest(location.state?.data['AMOUNT'])
        });
        // AMOUNT
        form.setFieldsValue({
            'PMTDET': location.state?.data['PMTDET']
        });

        form.setFieldsValue({
            'NOTE': location.state?.data['NOTE']
        });
        // AMOUNT
        form.setFieldsValue({
            'INFOTOBENEF': location.state?.data['INFOTOBENEF']?.length >195 ? location.state?.data['INFOTOBENEF'].substring(0,195) : location.state?.data['INFOTOBENEF']
        });
        // COMISSION
        let valueA = checkAmountForRequest(location.state?.data['AMOUNT']);

        if (!isNaN(valueA)) {
            setCommissionLoading(true);

            getCustomerCommission({
                PAYMENT_TYPE: "DXA",
                CIF: getCurrentCompany().customerNo,
                CUSTACC: findAccount?.IBAN,
                AMOUNT: valueA,
                CUR: findAccount?.CCY_NAME,
                BENEFBANKCODE: location.state?.data['BENEFBANKCODE'],
                BENEFACC: location.state?.data['BENEFACC'],
                BENEFTAXID: location.state?.data['BENEFTAXID'],
                PMTDET: location.state?.data['PMTDET'],
            }).then(res => {
                setCommissionLoading(false);

                form.setFieldsValue({
                    'CUSTACCFORCOM': res.COM_AMOUNT ?? ''
                });

                setCommissionAmount(old_value => res.COM_AMOUNT ?? '')
            })
        } else {
            setCommissionLoading(false);

            form.setFieldsValue({
                'CUSTACCFORCOM': ''
            });

            setCommissionAmount(old_value => '');
        }
        setLoadingData(false)
    }

    const loadDataTemplate = async (tempData) => {
       
        setLoadingData(true)
        const docid = documentNumber;
        form.resetFields();
        if (tempData?.trnData) {
            fillCurrentFormTemplate(form, tempData?.trnData)
            updateParentComponentFormData();
        }
        if (docid !== "" && docid !== undefined) {
            form.setFieldsValue({
                'PMTCUSTID': docid
            });
            setDocumentNumber(old_value => docid)
        }
        // CUSTACC
        const findAccount = allAccounts?.find(row => row.IBAN == tempData?.trnData.CUSTACC);
        if (findAccount !== undefined) {
            setFromBranch(findAccount);
            // if (docid === "" || docid === undefined) {
                updateDocumentNumber();
            // }
            form.setFieldsValue({
                'CUSTACC': tempData?.trnData.CUSTACC
            });
        }
        // BENEFACC
        if (tempData?.trnData.BENEFACC !== undefined && tempData?.trnData.BENEFACC !== null) {
            const dataBENEFACC = await getTeskilatCodesByFilter(tempData?.trnData.BENEFACC, '');
            if (dataBENEFACC !== undefined && dataBENEFACC.length > 0) {
                setFormFields(old_data => ({
                    ...old_data,
                    BENEFBANKCODE: dataBENEFACC[0].code,
                    BENEFNAME: dataBENEFACC[0].name,
                    BENEFACC: dataBENEFACC[0].orgcode,
                    BENEFTAXID: dataBENEFACC[0].taxId,
                }))
                setSelectedAccount(true);
            }
        }
        // BUDGETCLASSCODE
        if (tempData?.trnData.BUDGETCLASSCODE !== undefined && tempData?.trnData.BUDGETCLASSCODE !== null) {
            const dataClassCodes = await getClassificationCodes();
            const filter_codes = dataClassCodes?.filter(row =>
                row.code.includes(tempData?.trnData.BUDGETCLASSCODE)
            );
            if (filter_codes?.length > 0) {
                setFormFields(old_data => ({
                    ...old_data,
                    BUDGETCLASSCODE: filter_codes[0].code,
                }))
                setClassCodes(old_data => filter_codes);
                setToBranch(old_data => filter_codes[0]);
            }
        }

        // BUDGETLEVELCODE
        if (tempData?.trnData.BUDGETLEVELCODE !== undefined && tempData?.trnData.BUDGETLEVELCODE !== null) {
            // temp_dataDataLevelCode.find(u => u.value === location.state?.data['BUDGETLEVELCODE'])
            setFormFields(old_data => ({
                ...old_data,
                BUDGETLEVELCODE: tempData?.trnData.BUDGETLEVELCODE,
            }))
            form.setFieldsValue({
                'BUDGETLEVELCODE': tempData?.trnData.BUDGETLEVELCODE
            });
        }
        // AMOUNT
        form.setFieldsValue({
            'AMOUNT': checkAmountForRequest(tempData?.trnData.AMOUNT)
        });
        // AMOUNT
        form.setFieldsValue({
            'PMTDET': tempData?.trnData.PMTDET.length > 70 ?  tempData?.trnData.PMTDET.substring(0,70) : tempData?.trnData.PMTDET
        });
        form.setFieldsValue({
            'NOTE': tempData?.trnData.NOTE
        });
        // AMOUNT
        form.setFieldsValue({
            'INFOTOBENEF': tempData?.trnData?.INFOTOBENEF?.length > 195 ? tempData?.trnData?.INFOTOBENEF.substring(0,195) : tempData?.trnData?.INFOTOBENEF
        });
        // COMISSION
        let valueA = checkAmountForRequest(tempData?.trnData.AMOUNT);

        if (!isNaN(valueA)) {
            setCommissionLoading(true);

            getCustomerCommission({
                PAYMENT_TYPE: "DXA",
                CIF: getCurrentCompany().customerNo,
                CUSTACC: findAccount?.IBAN,
                AMOUNT: valueA,
                CUR: findAccount?.CCY_NAME,
                BENEFBANKCODE: tempData?.trnData.BENEFBANKCODE,
                BENEFACC: tempData?.trnData.BENEFACC,
                BENEFTAXID: tempData?.trnData.BENEFTAXID,
                PMTDET: tempData?.trnData.PMTDET.length > 70 ?  tempData?.trnData.PMTDET.substring(0,70) : tempData?.trnData.PMTDET,

            }).then(res => {
                setCommissionLoading(false);

                form.setFieldsValue({
                    'CUSTACCFORCOM': res.COM_AMOUNT ?? ''
                });

                setCommissionAmount(old_value => res.COM_AMOUNT ?? '')
            })
        } else {
            setCommissionLoading(false);

            form.setFieldsValue({
                'CUSTACCFORCOM': ''
            });

            setCommissionAmount(old_value => '');
        }

        // BENEFBANKCODE
        form.setFieldsValue({
            'receiver_code': '210005'
        });

        // BENEFBANKNAME
        form.setFieldsValue({
            'receiver_name': t("newTransfer.stateTreasuryAgencyDXA")
        });

        setLoadingData(false)
    }

    const loadDataTemplate2 = async (tempData) => {
        setLoadingData(true)
        // load Account
        setLoadingAccount(true);
        const data = await getAccounts(getCurrentCompany());
        let temp_data = [];
        for (let row of data) {
            if (row.STATUS !== "0") {
                if (row.CCY_NAME.toString().toLowerCase() !== 'azn') {
                    continue;
                }

                // @ts-ignore
                temp_data.push({
                    label: row.NICKNAME ? row.NICKNAME : row.IBAN,
                    value: row.IBAN,
                    extra: `${financial(row.BALANCE_LC)} ${row.CCY_NAME}`
                });
            }
        }
        setAllAccounts(data.filter(row => row.STATUS !== "0"));
        setFromSelectOptions(old_data => temp_data);
        setLoadingAccount(false);
        // updateLevelCode
        const dataLevelCode = await getLevelCodes();
        let temp_dataDataLevelCode = [];
        for (let row of dataLevelCode) {
            // @ts-ignore
            temp_dataDataLevelCode.push({
                label: `${row.code}-${row.name}`,
                value: row.code
            });
        }
        setLevelCodeOptions(old_data => temp_dataDataLevelCode);
        // callgetClassificationCodes
        const dataClassCodes = await getClassificationCodes();
        setAllClassCodes(old_data => dataClassCodes);

        // CUSTACC
        const findAccount = data?.find(row => row.IBAN == tempData?.trnData.CUSTACC);
        if (findAccount !== undefined) {
            setFromBranch(findAccount);
            // if (form.getFieldValue('PMTCUSTID') === "" || form.getFieldValue('PMTCUSTID') === undefined) {
                updateDocumentNumber();
            // }
            form.setFieldsValue({
                'CUSTACC': tempData?.trnData.CUSTACC
            });
        }
        // BENEFACC
        if (tempData?.trnData.BENEFACC !== undefined && tempData?.trnData.BENEFACC !== null) {
            const dataBENEFACC = await getTeskilatCodesByFilter(tempData?.trnData.BENEFACC, '');
            if (dataBENEFACC !== undefined && dataBENEFACC.length > 0) {
                setFormFields(old_data => ({
                    ...old_data,
                    BENEFBANKCODE: dataBENEFACC[0].code,
                    BENEFNAME: dataBENEFACC[0].name,
                    BENEFACC: dataBENEFACC[0].orgcode,
                    BENEFTAXID: dataBENEFACC[0].taxId,
                }))
                setSelectedAccount(true);
            }
        }
        // BUDGETCLASSCODE
        if (tempData?.trnData.BUDGETCLASSCODE !== undefined && tempData?.trnData.BUDGETCLASSCODE !== null) {
            const filter_codes = dataClassCodes?.filter(row =>
                row.code.includes(tempData?.trnData.BUDGETCLASSCODE)
            );
            if (filter_codes?.length > 0) {
                setFormFields(old_data => ({
                    ...old_data,
                    BUDGETCLASSCODE: filter_codes[0].code,
                }))
                setClassCodes(old_data => filter_codes);
                setToBranch(old_data => filter_codes[0]);
            }
        }

        // BUDGETLEVELCODE
        if (tempData?.trnData.BUDGETLEVELCODE !== undefined && tempData?.trnData.BUDGETLEVELCODE !== null) {
            // temp_dataDataLevelCode.find(u => u.value === location.state?.data['BUDGETLEVELCODE'])
            setFormFields(old_data => ({
                ...old_data,
                BUDGETLEVELCODE: tempData?.trnData.BUDGETLEVELCODE,
            }))
            form.setFieldsValue({
                'BUDGETLEVELCODE': tempData?.trnData.BUDGETLEVELCODE
            });
        }
        // AMOUNT
        form.setFieldsValue({
            'AMOUNT': checkAmountForRequest(tempData?.trnData.AMOUNT)
        });
        // AMOUNT
        form.setFieldsValue({
            'PMTDET': tempData?.trnData.PMTDET.length > 70 ?  tempData?.trnData.PMTDET.substring(0,70)?.trim() : tempData?.trnData.PMTDET?.trim()
        });
        form.setFieldsValue({
            'NOTE': tempData?.trnData.NOTE
        });
        // AMOUNT
        form.setFieldsValue({
            'INFOTOBENEF': tempData?.trnData?.INFOTOBENEF?.length >195 ? tempData?.trnData?.INFOTOBENEF.substring(0,195) : tempData?.trnData?.INFOTOBENEF
        });
        // COMISSION
        let valueA = checkAmountForRequest(tempData?.trnData.AMOUNT);

        if (!isNaN(valueA)) {
            setCommissionLoading(true);

            const res = await getCustomerCommission({
                PAYMENT_TYPE: "DXA",
                CIF: getCurrentCompany().customerNo,
                CUSTACC: findAccount?.IBAN,
                AMOUNT: valueA,
                CUR: findAccount?.CCY_NAME,
                BENEFBANKCODE: tempData?.trnData.BENEFBANKCODE,
                BENEFACC: tempData?.trnData.BENEFACC,
                BENEFTAXID: tempData?.trnData.BENEFTAXID,
                PMTDET: tempData?.trnData.PMTDET.length > 70 ?  tempData?.trnData.PMTDET.substring(0,70) : tempData?.trnData.PMTDET
            })
            if (res !== undefined) {
                setCommissionLoading(false);

                form.setFieldsValue({
                    'CUSTACCFORCOM': res.COM_AMOUNT ?? ''
                });

                setCommissionAmount(old_value => res.COM_AMOUNT ?? '')
            }
        } else {
            setCommissionLoading(false);

            form.setFieldsValue({
                'CUSTACCFORCOM': ''
            });

            setCommissionAmount(old_value => '');
        }

        // BENEFBANKCODE
        form.setFieldsValue({
            'receiver_code': '210005'
        });

        // BENEFBANKNAME
        form.setFieldsValue({
            'receiver_name': t("newTransfer.stateTreasuryAgencyDXA")
        });
        updateParentComponentFormData()
        setLoadingData(false)
    }

    const callgetClassificationCodes = async () => {
        const data = await getClassificationCodes();
        setAllClassCodes(old_data => data);
    }

    const updateDocumentNumber = async () => {
        const document_number = await getDxaDocumentNumber(getCurrentCompany());
        form.setFieldsValue({
            'PMTCUSTID': document_number
        });

        setDocumentNumber(old_value => document_number)
    }

    const getSelectedFromBranch = (value: any) => {
        const findAccount = allAccounts?.find(row => row.IBAN == value);
        setFromBranch(findAccount);
        if (!form.getFieldValue('PMTCUSTID') && value) {
            updateDocumentNumber();
        }

    }

    useEffect(() => {
        if(ibanNumber.iban && allAccounts && ibanNumber.ccy_name?.toString()?.toLowerCase() === 'azn'){
        const findAccount=allAccounts?.find(row => row.IBAN==ibanNumber.iban);
        setFromBranch(findAccount);

        if (!form.getFieldValue('PMTCUSTID') && ibanNumber.iban){
            updateDocumentNumber();
        }

        setIbanNumber({iban: undefined, ccy_name: undefined})
        }

      }, [ibanNumber, allAccounts])

    const onCloseSuccessModal = () => {
        resetForm(form);
        resetFormFields();
    }

useEffect(() => {
    setPdfCount(form.getFieldValue('pdf_files')?.length)
},[form.getFieldValue('pdf_files')])

    const newTransferFunc = async(RequestType: string, retry: boolean = false) => {
        let amount = checkAmountForRequest(form.getFieldValue('AMOUNT'));
        let comission = checkAmountForRequest(form.getFieldValue('CUSTACCFORCOM'));
        const selected_level = levelCodeOptions.find(row => row.value == form.getFieldValue('BUDGETLEVELCODE'));
        let pdf_files = form.getFieldValue('pdf_files') ?? [];

       if(ibankRef !== "") {
              await   deleteFileById(ibankRef)
              await new Promise(res => setTimeout(res, 1000)); 
             }

        if (!retry && retryRequest === null) {
            const req = {
                trnRequestType: RequestType,
                ccy: 1,
                ccyType: fromBranch?.CCY_NAME,
                PMTCUSTID: form.getFieldValue('PMTCUSTID'),
                CUSTCIF: getCurrentCompany().customerNo,
                CUSTACC: fromBranch?.IBAN,
                BENEFBANKCODE: form.getFieldValue('BENEFBANKCODE'),
                BENEFNAME: form.getFieldValue('BENEFNAME'),
                BENEFACC: form.getFieldValue('BENEFACC')?.toUpperCase(),
                BENEFTAXID: form.getFieldValue('BENEFTAXID'),
                BUDGETCLASSCODE: form.getFieldValue('BUDGETCLASSCODE'),
                BUDGETLEVELCODE: form.getFieldValue('BUDGETLEVELCODE'),
                BUDGETLEVELCODENAME: selected_level ? selected_level.label : '',
                AMOUNT: amount,
                PMTDET: form.getFieldValue('PMTDET'),
                INFOTOBENEF: form.getFieldValue('INFOTOBENEF'),
                NOTE: form.getFieldValue('NOTE'),
                CUSTACCFORCOM: fromBranch?.IBAN,
                COMMAMOUNT: comission,
                ibankRef: ibankRef,
                attachedPDF: pdfCount
            };
            setRetryRequest(req);
            const data = newMoneyTransferDxa(req);
            // resetForm(form);
            // resetFormFields();
            return data;
        }
        else {
            if(retryRequest !== null)
                retryRequest['trnRequestType'] = RequestType;
            const data = newMoneyTransferDxa(retryRequest);
            // resetForm(form);
            // resetFormFields();
            return data;
        }
    }

    const submitHandler = async (args: any) => {
        await calculateCommission(args.AMOUNT);
        let amount = financial(form.getFieldValue('AMOUNT'));
        let comission = financial(form.getFieldValue('CUSTACCFORCOM'));

        let pdf_files = form.getFieldValue('pdf_files') ?? [];
        modalDataInitial.pdfFiles = [];

        if (pdf_files.length > 0) {

            for (let file of pdf_files) {
                modalDataInitial.pdfFiles.push({
                    'label': file.name,
                    'file': file
                })
            }
        }

        const selected_level = levelCodeOptions.find(row => row.value == args.BUDGETLEVELCODE);

        setModalData(old_data => ({
            ...modalDataInitial,

            groups: [
                {
                    title: false,
                    tableHasBorderBottom: true,
                    data: [
                        {
                            label: t("transfers.sender"),
                            value: getCurrentCompany().name
                        },
                        {
                            label: t("salary.documentNo"),
                            value: `${args.PMTCUSTID}`
                        },
                        {
                            label: t("transfers.fromAccount"),
                            value: `${fromBranch?.IBAN} ${fromBranch?.CCY_NAME}`
                        },
                    ]
                },
                {
                    title: t("requisites.beneficiaryBank"),
                    tableHasBorderBottom2: true,
                    tableHasMarginBottom: true,
                    data: [
                        {
                            label: t("requisites.code"),
                            value: `210005`
                        },
                        {
                            label: t("requisites.name"),
                            value: t("newTransfer.stateTreasuryAgencyDXA")
                        }
                    ]
                },
                {
                    title: t("requisites.beneficiary"),
                    data: [
                        {
                            label: t("transfers.accountNumber"),
                            value: `${args.BENEFACC?.toUpperCase()}`
                        },
                        {
                            label: t("requisites.name"),
                            value: `${args.BENEFNAME}`
                        },
                        {
                            label: t("requisites.taxID"),
                            value: args.BENEFTAXID ?? ''
                        }
                    ]
                },
                {
                    title: t("transfers.budgetCodes"),
                    // tableHasBorderBottom2 : true,
                    // tableHasMarginBottom: true,
                    data: [
                        {
                            label: t("newTransfer.budgetClassificationCodes"),
                            value: `${args.BUDGETCLASSCODE}`
                        },
                        {
                            label: t("newTransfer.budgetLevelCode"),
                            value: `${selected_level.label}`
                        }
                    ]
                },
                {
                    title: '',
                    data: [
                        {
                            label: t("common.amount"),
                            value: `${amount} ${fromBranch?.CCY_NAME}`
                        },
                        {
                            label: t("home.commission"),
                            value: `${comission} ${fromBranch?.CCY_NAME}`
                        },
                        {
                            label: t("accountStatement.paymentDetails"),
                            value: `${args.PMTDET}`
                        },
                        {
                            label: t("transfers.infoForBeneficiary"),
                            value: args.INFOTOBENEF ?? ''
                        },
                        args.NOTE !== undefined ? {
                            label: t("newTransfer.note"),
                            value: args.NOTE ?? ''
                        } : undefined,
                    ]
                }
            ],
        }))

        setNextModalVisible(old_value => true);
    }

    const getFileList = (info: any) => {
        form.setFieldsValue({
            'pdf_files': info.fileList
        });
    }

    const calculateCommission = async (e: any) => {
  let value;
  if (e?.target !== undefined) {
    value = checkAmountForRequest(e.target.value);
  } else {
    value = checkAmountForRequest(e);
  }

  if (!isNaN(value)) {
    setCommissionLoading(true);

    try {
      const res = await getCustomerCommission({
        PAYMENT_TYPE: "DXA",
        CIF: getCurrentCompany().customerNo,
        CUSTACC: fromBranch?.IBAN,
        AMOUNT: value,
        CUR: fromBranch?.CCY_NAME,
        BENEFBANKCODE: form.getFieldValue("BENEFBANKCODE"),
        BENEFACC: form.getFieldValue("BENEFACC")?.toUpperCase(),
        BENEFTAXID: form.getFieldValue("BENEFTAXID"),
        PMTDET: form.getFieldValue("PMTDET"),
      });

      setCommissionLoading(false);

      form.setFieldsValue({
        CUSTACCFORCOM: res.COM_AMOUNT ?? "",
      });

      setCommissionAmount(res.COM_AMOUNT ?? "");

      return res.COM_AMOUNT ?? "";
    } catch (err) {
      setCommissionLoading(false);
      console.error("Commission fetch error:", err);

      form.setFieldsValue({
        CUSTACCFORCOM: "",
      });
      setCommissionAmount("");
      return "";
    }
  } else {
    setCommissionLoading(false);

    form.setFieldsValue({
      CUSTACCFORCOM: "",
    });

    setCommissionAmount("");
    return "";
  }
};


    const openSaveAsTemplateModal = () => {

        setSaveAsTemplatePopupVisible(old_data => false)

        form.validateFields().then(res => {
            setSaveAsTemplatePopupVisible(old_data => true)

        }).catch(err_input_list => {

        })
    }

    const updateDocumentNumberAndCommission = (data) => {
        loadDataTemplate(data)
    }

    const resetFormFields = () => {
        setFormFields(old_data => { })
    }

    const checkVoen = (e) => {
        let value = e?.target?.value;

        if (value?.length > 0 && value?.length < 10) {
            setVoenError(true)
        } else {
            setVoenError(false)
        }
    }

    const checkAccount = (e) => {
        let value = e?.target?.value;

        if (value?.length < 28) {
            setSelectedAccount(false)
        } else {
            setSelectedAccount(true)
        }
    }

    const removeFile = (index:any)=>{
        const myNewFiles = [...fileList]
        myNewFiles.splice(index, 1);
        setFileList(myNewFiles)
    }
    return (
        <>
            <Row>
                <Col flex={'700px'} className="own-account">
                    <Card bordered={false}>
                        <Row justify='start' className="own-account__form">
                            <Form
                                labelCol={{ flex: '190px' }}
                                wrapperCol={{ flex: 1 }}
                                className='full'
                                onSubmit={(e) => e.preventDefault(e)}
                                onFinish={submitHandler}
                                id={'form'}
                                form={form}
                                autoComplete="off"
                                onValuesChange={updateParentComponentFormData}
                                scrollToFirstError={{
                                    behavior: 'smooth',
                                    block: 'center',
                                    inline: 'center',
                                }}
                            >

                                {!addOrEditPage && <div className='flex ' >
                                    <InputField
                                        labelItem={t("salary.documentNo")}
                                        placeholder={t("salary.automatically")}
                                        name={'PMTCUSTID'}
                                        required={true}
                                        form={form}
                                        value={documentNumber}
                                        message={true}
                                        maxLength={25}
                                        allowLatinNumber ={true}
                                    />

                                    <Button
                                        size={'large'}
                                        icon={<SaveIco />}
                                        className="blue-button transfer__button flex align_center justify_center create_tr_template_btn"
                                        onClick={e => setTemplatePopupVisible(true)}
                                    >
                                        {OWNACCOUNT.PATTERN}
                                    </Button>
                                </div>}

                                <SelectField
                                    labelItem={t("transfers.fromAccount")}
                                    placeholder={t("accountStatement.chooseAccount")}
                                    options={fromSelectOptions}
                                    name={'CUSTACC'}
                                    onChange={getSelectedFromBranch}
                                    required={true}
                                    form={form}
                                    account={true}
                                    notFoundContent={!loadingAccount ? t("newTransfer.noAccountCorrespondingCurrency") : undefined}
                                    defaultValue={ibanNumber.ccy_name?.toString()?.toLowerCase() === 'azn' ? ibanNumber.iban : undefined}
                                />

                                <Divider plain orientation="left" className={'tab_divider_left'} >{t("newTransfer.beneficiaryBank")}</Divider>

                                <InputField
                                    className="not-required dark-input isReadOnly"
                                    labelItem={t("requisites.code")}
                                    placeholder=""
                                    readOnly={true}
                                    value={'210005'}
                                    required={false}
                                    maxLength={6}
                                    isNumeric={true}
                                    onlyNumber={true}
                                    form={form}
                                    staticValue={true}
                                    name={'receiver_code'}
                                />

                                <InputField
                                    className="not-required dark-input isReadOnly"
                                    labelItem={t("requisites.name")}
                                    placeholder=""
                                    readOnly={true}
                                    value={t("newTransfer.stateTreasuryAgencyDXA")}
                                    required={false}
                                    onlyLetter={true}
                                    allowLatin={true}
                                    form={form}
                                    staticValue={true}
                                    name={'receiver_name'}
                                />

                                <Divider plain orientation="left" className={'tab_divider_left'} >{t("transfers.beneficiary")}</Divider>

                                <div className='flex'>
                                    <InputField
                                        labelItem={t("deposit.accountNumber")}
                                        placeholder={t("newTransfer.atLeast3Char")}
                                        allowClear={true}
                                        allowLatin={true}
                                        className={"is_upper_case not_show_required_props isReadOnly ant-input-border"}
                                        required={true}
                                        maxLength={'28'}
                                        name={'BENEFACC'}
                                        value={formFields?.BENEFACC}
                                        form={form}
                                        readOnly={!fromBranch?.ACCOUNT_NO}
                                        onKeyUp={() => { updateBankCodes(false) }}
                                        // onPaste={() => { updateBankCodes(false) }}
                                        autoComplete={true}
                                        options={bankCodes}
                                        showMessage={accMessage}
                                        message={t("transfers.accountNotFound")}
                                        filterRowClick={updateToBankCodeAndName}
                                        onBlur={checkAccount}
                                        upper={true}
                                    />
                                    <Col flex="40px" style={{ marginLeft: 10 }} >
                                        <Button
                                            size={'large'}
                                            icon={<SearchIco />}
                                            className="blue-button transfer__button flex align_center justify_center search_btn"
                                            onClick={() => { updateBankCodes(true) }}
                                            disabled={!fromBranch?.ACCOUNT_NO}
                                        >
                                        </Button>
                                    </Col>

                                    <Modal
                                        title={t("newTransfer.organizations")}
                                        closeIcon={<ModalCloseIco />}
                                        centered
                                        visible={codeModalVisible}
                                        onOk={() => setCodeModalVisible(false)}
                                        onCancel={() => setCodeModalVisible(false)}
                                        width={700}
                                        className={'manage_faster_menus swift_modal table_scroll_modal'}
                                        keyboard={false}
                                        focusTriggerAfterClose={false}
                                        footer={false}
                                    >
                                        <Form
                                            layout="vertical"
                                            onFinish={(e) => { }}
                                            autoComplete="off"
                                        >
                                            <table className={'table table-hover swift_table b_code_table'}>
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            <InputField
                                                                labelItem={t("deposit.accountNumber")}
                                                                placeholder={t("newTransfer.atLeast2Char")}
                                                                className={'hide_placeholder_on_focus input-border-modal'}
                                                                value={formFields?.BENEFACC}
                                                                name={'BENEFACC'}
                                                                form={form}
                                                                isNumeric={false}
                                                                maxLength={'6'}
                                                                onKeyUp={() => { updateBankCodes(true) }}
                                                                suffix={<Button onClick={() => { updateBankCodes(true) }} type={"ghost"} className={'transparent'} icon={<InputSearchIco />} />}
                                                            />
                                                        </th>

                                                        <th>
                                                            <InputField
                                                                labelItem={t("requisites.name")}
                                                                placeholder={t("transfers.atLeast3Char")}
                                                                className={'hide_placeholder_on_focus input-border-modal'}
                                                                allowLatin={true}
                                                                name={'BENEFBANKNAME_FILTER'}
                                                                form={form}
                                                                onKeyUp={() => { updateBankCodes(true) }}
                                                                suffix={<Button onClick={() => { updateBankCodes(true) }} type={"ghost"} className={'transparent'} icon={<InputSearchIco />} />}
                                                            />
                                                        </th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {
                                                        bankCodes?.map(row => {
                                                            return (
                                                                <tr onClick={() => { updateToBankCodeAndName(row) }} >
                                                                    <td>{row.code}</td>
                                                                    <td>{row.name}</td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </Form>


                                    </Modal>
                                </div>


                                <InputField
                                    labelItem={t("requisites.name")}
                                    placeholder={t("newTransfer.organizationName")}
                                    className="dark-input not-required isReadOnly"
                                    onlyLetter={true}
                                    form={form}
                                    name={'BENEFNAME'}
                                    value={formFields?.BENEFNAME}
                                    readOnly={(!fromBranch?.ACCOUNT_NO || selectedAccount)}
                                    disabled={true}
                                />

                                <InputField
                                    labelItem={t("requisites.taxID")}
                                    placeholder=""
                                    className="dark-input not-required isReadOnly"
                                    isNumeric={true}
                                    onlyNumber={true}
                                    maxLength={'10'}
                                    name={'BENEFTAXID'}
                                    value={formFields?.BENEFTAXID}
                                    form={form}
                                    readOnly={(!fromBranch?.ACCOUNT_NO || selectedAccount)}
                                    onBlur={checkVoen}
                                    message={t("newTransfer.enterValidTaxID")}
                                    notValid={voenError}
                                    disabled={true}
                                />

                                <Divider plain orientation="left" className={'tab_divider_left'} >{t("newTransfer.budgetCodes")}</Divider>

                                <div className='flex'>
                                    <InputField
                                        labelItem={t("newTransfer.budgetClassificationCodes")}
                                        placeholder={t("newTransfer.atLeast2Char")}
                                        allowClear={true}
                                        className="not_show_required_props isReadOnly ant-input-border"
                                        isNumeric={true}
                                        onlyNumber={true}
                                        name={'BUDGETCLASSCODE'}
                                        value={formFields?.BUDGETCLASSCODE}
                                        required={true}
                                        form={form}
                                        showMessage={showMessage}
                                        message={t("transfers.budgetCodeError")}
                                        readOnly={!fromBranch?.ACCOUNT_NO}
                                        onKeyUp={() => { updateClassCodes(false) }}
                                        autoComplete={true}
                                        options={classCodes}
                                        filterRowClick={updateToClassCodeAndName}
                                    />
                                    <Col flex="40px" style={{ marginLeft: 10 }} >
                                        <Button
                                            size={'large'}
                                            icon={<SearchIco />}
                                            className="blue-button transfer__button flex align_center justify_center search_btn"
                                            onClick={() => { updateClassCodes(true) }}
                                            disabled={!fromBranch?.ACCOUNT_NO}
                                        >
                                        </Button>
                                    </Col>

                                    <Modal
                                        title={t("newTransfer.budgetClassificationCode")}
                                        closeIcon={<ModalCloseIco />}
                                        centered
                                        visible={classModalVisible}
                                        onOk={() => setClassModalVisible(false)}
                                        onCancel={() => setClassModalVisible(false)}
                                        width={700}
                                        className={'manage_faster_menus swift_modal table_scroll_modal'}
                                        keyboard={false}
                                        focusTriggerAfterClose={false}
                                        footer={false}
                                    >
                                        <Form
                                            layout="vertical"
                                            onFinish={(e) => { }}
                                            autoComplete="off"
                                        >
                                            <table className={'table table-hover swift_table b_code_table'}>
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            <InputField
                                                                labelItem={t("requisites.code")}
                                                                placeholder={t("newTransfer.atLeast2Char")}
                                                                className={'hide_placeholder_on_focus input-border-modal'}
                                                                value={formFields?.BUDGETCLASSCODE}
                                                                name={'BUDGETCLASSCODE'}
                                                                form={form}
                                                                isNumeric={true}
                                                                onlyNumber={true}
                                                                maxLength={'6'}
                                                                onKeyUp={() => { updateClassCodes(true) }}
                                                                suffix={<Button onClick={() => { updateClassCodes(true) }} type={"ghost"} className={'transparent'} icon={<InputSearchIco />} />}
                                                            />
                                                        </th>

                                                        <th>
                                                            <InputField
                                                                labelItem={t("transfers.description")}
                                                                placeholder={t("transfers.atLeast3Char")}
                                                                className={'hide_placeholder_on_focus input-border-modal'}
                                                                allowLatin={true}
                                                                name={'BUDGETCLASSNAME_FILTER'}
                                                                form={form}
                                                                onKeyUp={() => { updateClassCodes(true) }}
                                                                suffix={<Button onClick={() => { updateClassCodes(true) }} type={"ghost"} className={'transparent'} icon={<InputSearchIco />} />}
                                                            />
                                                        </th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {
                                                        classCodes?.map(row => {
                                                            return (
                                                                <tr onClick={() => { updateToClassCodeAndName(row) }} >
                                                                    <td>{row.code}</td>
                                                                    <td>{row.name}</td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </Form>


                                    </Modal>
                                </div>

                                <SelectField
                                    labelItem={t("newTransfer.budgetLevelCode")}
                                    options={levelCodeOptions}
                                    name={'BUDGETLEVELCODE'}
                                    required={true}
                                    form={form}
                                    disabled={!fromBranch?.ACCOUNT_NO}
                                    showSearch={true}
                                    className={'isDisabled'}

                                />

                                <Divider className='no_text' />

                                <div className={'flex'}  >
                                    <AmountField
                                        labelItem={t("common.amount")}
                                        placeholder=""
                                        suffix={fromBranch?.CCY_NAME}
                                        name={'AMOUNT'}
                                        className={`amount_and_commission_col amount_input isDisabled`}
                                        required={true}
                                        form={form}
                                        disabled={!fromBranch?.ACCOUNT_NO}
                                        onBlur={calculateCommission}
                                    />

                                    <Col className={'commission_col mobile-select'} >
                                        <InputField
                                            labelCol={2}
                                            labelItem={t("home.commission")}
                                            placeholder=""
                                            className="dark-input commission_input commission_border isReadOnly"
                                            readOnly={true}
                                            suffix={fromBranch?.CCY_NAME}
                                            name={'CUSTACCFORCOM'}
                                            value={commissionAmount}
                                            hasLoading={commissionLoading}
                                            form={form}
                                            required={true}
                                            message={''}
                                            notValid={form.getFieldValue('CUSTACCFORCOM') == ''}
                                        />
                                    </Col>
                                </div>

                                <TextAreaField
                                    visible={true}
                                    labelItem={t("accountStatement.paymentDetails")}
                                    placeholder=""
                                    showCount={true}
                                    maxLength={'70'}
                                    name={'PMTDET'}
                                    required={true}
                                    form={form}
                                    // allowDestination={true}
                                    allowLatin={true}
                                    readOnly={!fromBranch?.ACCOUNT_NO}
                                    className={'isDisabled'}
                                />

                                <TextAreaField
                                    visible={true}
                                    labelItem={t("transfers.infoForBeneficiary")}
                                    placeholder=""
                                    showCount={true}
                                    maxLength={'195'}
                                    className={'no_required isDisabled'}
                                    name={'INFOTOBENEF'}
                                    form={form}
                                    readOnly={!fromBranch?.ACCOUNT_NO}
                                    allowLatin={true}
                                />


                                <div className={'flex'}>
                                    <Col flex={1}>
                                        <TextAreaField
                                            visible={visible}
                                            className='not-required plus_minus_area isDisabled'
                                            labelItem={t("newTransfer.note")}
                                            placeholder={t("newTransfer.notTransferableToBank")}
                                            showCount={true}
                                            maxLength={'180'}
                                            name={'NOTE'}
                                            readOnly={!fromBranch?.ACCOUNT_NO}
                                            form={form}
                                            // allowAllSymboll={true}
                                            allowLatin={true}
                                        />
                                    </Col>
                                    <Button
                                        className="icon-button add-remove-btn"
                                        icon={visible ? <MinusSmallIco /> : <PlusSmallIco />}
                                        onClick={() => setVisible(!visible)}
                                    />
                                </div>

                                <FileUpload
                                    className='file-upload isDisabled'
                                    labelItem={t("newTransfer.attachPDF")}
                                    accept="application/pdf"
                                    multiple={false}
                                    required={false}
                                    form={form}
                                    name={'pdf_files'}
                                    onChange={getFileList}
                                    fileLimit={10}
                                    checkSize={true}
                                    disabled={!fromBranch?.ACCOUNT_NO}
                                    editFileList={fileList}
                                    ibankRef={ibankRef}
                                    editOrRepeat={editOrRepeat}
                                    removeFile={removeFile}
                                />

                                {!addOrEditPage && <div className='flex button_row' >
                                    <Button
                                        size={'large'}
                                        icon={<SaveBlueIco />}
                                        className="light-button btn save_btn flex align_center justify_center"
                                        htmlType={"button"}
                                        onClick={openSaveAsTemplateModal}
                                    >
                                        {OWNACCOUNT.SAVE}
                                    </Button>

                                    <div className={'flex flex_wrap'}>


                                        <Button

                                            size={'large'}
                                            icon={<RefreshIco />}
                                            className="light-button refresh_btn btn flex align_center justify_center"
                                            onClick={(e) => { resetFormFields(); resetForm(form); form.setFieldsValue({'BUDGETLEVELCODE' : undefined}) }}
                                        >
                                            {t(OWNACCOUNT.REFRESH)}
                                        </Button>

                                        <Button
                                            size={'large'}
                                            disabled={showMessage || accMessage}
                                            htmlType="submit"
                                            className="blue-button next_btn btn flex align_center justify_center"
                                        >
                                            {OWNACCOUNT.NEXT}
                                        </Button>
                                    </div>

                                </div>}

                            </Form>
                        </Row>
                    </Card>
                </Col>
            </Row>

            <NextModal
                errorIcon={<EroorIco />}
                callBackApi={newTransferFunc}
                visible={nextModalVisible}
                // onClose={setNextModalVisible}
                onClose={() => { setNextModalVisible(false); setRetryRequest(null); }}
                onCloseSuccessModal={() => { onCloseSuccessModal() }}
                data={modalData}
                className={'transfer_own_account'}
                nextModalTitle={t("home.transfer")}
                nextModalText={`Əməliyyat uğurla saxlanılmış, imzalanmışdır və banka göndərilməsini gözləməkdədir.`}
                currentForm={form}
                transfer={true}
                repeatPdfList={fileList}
                tableData={tableData}
                editTransfer={ibankRef !== undefined && ibankRef !== '' && ibankRef !== null}
            />

            <TemplatePopup
                visible={templatePopupVisible}
                onClose={setTemplatePopupVisible}
                trnType={'DXA'}
                currentForm={form}
                updateAfterTemplate={updateDocumentNumberAndCommission}
            />

            <SaveAsTemplate
                visible={saveAsTemplatePopupVisible}
                onClose={setSaveAsTemplatePopupVisible}
                trnType={'DXA'}
                currentForm={form}
            />

            {
                loadingData ? <FullScreenLoading /> : <></>
            }
        </>
    )
}

const mapDispatchToProps = {setIbanNumber}

const mapStateToProps = (state: any, ownProps: any,) => ({
    ownProps: ownProps,
    ibanNumber: (state.accountsStatement && state.accountsStatement.ibanNumber) ? state.accountsStatement.ibanNumber : {}
});

export default connect(mapStateToProps, mapDispatchToProps)(Dxa)
